export const USERFLOW_TOKEN = {
  development: 'ct_te3mhftzqfbiricghos7ooyche',
  production: 'ct_lzdyx2qz5na4pduq3xsk5vvfoy',
  staging: 'ct_te3mhftzqfbiricghos7ooyche',
}[process.env.NODE_ENV]
